var EventModel = /** @class */ (function () {
    function EventModel() {
    }
    return EventModel;
}());
export { EventModel };
